import _ from "underscore";
//#region src/helpers/base_model_helper.ts
let BaseModelHelper;
(function(_BaseModelHelper) {
	function map(models, property) {
		const modelById = {};
		models.forEach((model) => {
			if (property in model.data) modelById[`${model.data[property]}`] = model;
		});
		return modelById;
	}
	_BaseModelHelper.map = map;
	function mapData(modelDatas, property) {
		const modelDataById = {};
		modelDatas.forEach((modelData) => {
			if (property in modelData) modelDataById[`${modelData[property]}`] = modelData;
		});
		return modelDataById;
	}
	_BaseModelHelper.mapData = mapData;
	function addToIdMap(models, idMapObject) {
		models.forEach((model) => {
			idMapObject[model.id.toString()] = model;
		});
	}
	_BaseModelHelper.addToIdMap = addToIdMap;
	function groupBy(models, property) {
		const sortedModels = _.sortBy(models, (model) => {
			return `${model.id}`;
		});
		return _.groupBy(sortedModels, (model) => {
			return `${model.data[property]}`;
		});
	}
	_BaseModelHelper.groupBy = groupBy;
	function groupDataBy(datas, property) {
		const sortedDatas = _.sortBy(datas, (model) => {
			return `${model._id}`;
		});
		return _.groupBy(sortedDatas, (data) => {
			return `${data[property]}`;
		});
	}
	_BaseModelHelper.groupDataBy = groupDataBy;
	function idMap(models) {
		return map(models, "_id");
	}
	_BaseModelHelper.idMap = idMap;
	function idMapData(modelDatas) {
		return mapData(modelDatas, "_id");
	}
	_BaseModelHelper.idMapData = idMapData;
	function modelMapToDataMap(modelMap) {
		const dataMap = {};
		Object.entries(modelMap).forEach(([key, model]) => {
			dataMap[key] = model.data;
		});
		return dataMap;
	}
	_BaseModelHelper.modelMapToDataMap = modelMapToDataMap;
	function uniquePropsFromModels(models, property, removeNullableValues) {
		if (removeNullableValues) return uniquePropsFromModelDatas(models.map((model) => model.data), property, removeNullableValues);
		return uniquePropsFromModelDatas(models.map((model) => model.data), property);
	}
	_BaseModelHelper.uniquePropsFromModels = uniquePropsFromModels;
	function uniquePropsFromModelDatas(datas, property, removeNullableValues) {
		const uniqueValuesByStringifiedValue = /* @__PURE__ */ new Map();
		datas.forEach((data) => {
			if (property in data) {
				const value = data[property];
				if (removeNullableValues && value === null) return;
				uniqueValuesByStringifiedValue.set(`${value}`, value);
			}
		});
		return Array.from(uniqueValuesByStringifiedValue.values());
	}
	_BaseModelHelper.uniquePropsFromModelDatas = uniquePropsFromModelDatas;
	function sortByIds(models, idArray) {
		const modelById = idMap(models);
		const sortedModels = [];
		idArray.forEach((mongoId) => {
			const model = modelById[mongoId.toString()];
			if (model) sortedModels.push(model);
		});
		return sortedModels;
	}
	_BaseModelHelper.sortByIds = sortByIds;
	function toJson(models) {
		if (!models) return [];
		return models.map((model) => {
			return model.data;
		});
	}
	_BaseModelHelper.toJson = toJson;
	function serialize(model, utils) {
		return serializeData(model.data, utils);
	}
	_BaseModelHelper.serialize = serialize;
	function serializeData(data, utils) {
		return brandObjectIds(data, utils);
	}
	_BaseModelHelper.serializeData = serializeData;
	function brandObjectIds(value, utils) {
		if (utils.isObjectId(value)) return {
			value: value.toString(),
			__brand: "ObjectId"
		};
		if (value === null || value === void 0) return value;
		if (Array.isArray(value)) return value.map((el) => brandObjectIds(el, utils));
		if (typeof value === "object") return Object.entries(value).reduce((acc, [key, val]) => {
			acc[key] = brandObjectIds(val, utils);
			return acc;
		}, {});
		return value;
	}
	function deserializeData(data, utils) {
		return unbrandObjectIds(data, utils);
	}
	_BaseModelHelper.deserializeData = deserializeData;
	function unbrandObjectIds(value, utils) {
		if (value === null || value === void 0) return value;
		if (Array.isArray(value)) return value.map((el) => unbrandObjectIds(el, utils));
		if (typeof value === "object") {
			if ("__brand" in value && value.__brand === "ObjectId" && "value" in value && typeof value.value === "string") return utils.toObjectId(value.value);
			return Object.entries(value).reduce((acc, [key, val]) => {
				acc[key] = unbrandObjectIds(val, utils);
				return acc;
			}, {});
		}
		return value;
	}
	function stringifyIdsHelper(value, utils) {
		if (utils.isObjectId(value)) return value.toString();
		if (Array.isArray(value)) return value.map((item) => stringifyIdsHelper(item, utils));
		if (value && typeof value === "object") {
			const newObj = {};
			Object.entries(value).forEach(([key, val]) => {
				newObj[key] = stringifyIdsHelper(val, utils);
			});
			return newObj;
		}
		return value;
	}
	function stringifyIds(data, utils) {
		return stringifyIdsHelper(data, utils);
	}
	_BaseModelHelper.stringifyIds = stringifyIds;
	function propsFromModels(models, property, removeNullableValues) {
		const array = [];
		const nonNullableArray = [];
		models.forEach((model) => {
			if (model.has(property)) {
				const value = model.data[property];
				if (!removeNullableValues) {
					array.push(value);
					return;
				}
				if (value === null) return;
				nonNullableArray.push(value);
			}
		});
		if (removeNullableValues) return nonNullableArray;
		return array;
	}
	_BaseModelHelper.propsFromModels = propsFromModels;
	function idArrayFromModels(models) {
		return propsFromModels(models, "_id");
	}
	_BaseModelHelper.idArrayFromModels = idArrayFromModels;
	function isEmptyLocalizationOverrideArray(value) {
		return Array.isArray(value) && value.length === 0;
	}
	_BaseModelHelper.isEmptyLocalizationOverrideArray = isEmptyLocalizationOverrideArray;
	function cleanEmptyLocalizationOverrideArrays(localizationOverrides) {
		if (!localizationOverrides) return {
			cleanedOverrides: [],
			overridesHaveChanged: false
		};
		let overridesHaveChanged = false;
		const cleanedOverrides = [];
		localizationOverrides.forEach((localizationOverride) => {
			const cleanedOverrideByFieldName = {};
			Object.entries(localizationOverride.overrideByFieldName).forEach(([fieldName, value]) => {
				if (isEmptyLocalizationOverrideArray(value)) {
					overridesHaveChanged = true;
					return;
				}
				Object.assign(cleanedOverrideByFieldName, { [fieldName]: value });
			});
			if (Object.keys(cleanedOverrideByFieldName).length) {
				cleanedOverrides.push({
					language: localizationOverride.language,
					overrideByFieldName: cleanedOverrideByFieldName
				});
				return;
			}
			overridesHaveChanged = true;
		});
		return {
			cleanedOverrides,
			overridesHaveChanged
		};
	}
	_BaseModelHelper.cleanEmptyLocalizationOverrideArrays = cleanEmptyLocalizationOverrideArrays;
})(BaseModelHelper || (BaseModelHelper = {}));
//#endregion
export { BaseModelHelper };

//# sourceMappingURL=base_model_helper.js.map